import { apiInstance } from "./api"

const endpoint = "/subscription-plan"

export const getSubscriptionPlan = async (subscriptionId) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}/${subscriptionId}`)

  return response.data
}

export const getSubscriptionPlans = async (queries) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}/`)

  return response.data
}